// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-stuhia {
  background: #2e2e2e;
  color: #fff;
  padding: 48px 0 0 0;
  font-size: 16px;
    font-family: "Gilroy", sans-serif;

}
.footer-stuhia .footer-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  flex-wrap: wrap;
}
.footer-stuhia .footer-col {
  flex: 1 1 220px;
  margin-bottom: 32px;
}
.footer-stuhia .footer-logo {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -1px;
}
.footer-stuhia .footer-socials {
  display: flex;
  gap: 16px;
  margin-top: 16px;
}
.footer-stuhia .footer-socials a {
  color: #fff;
  font-size: 1.3rem;
  transition: color 0.2s;
}
.footer-stuhia .footer-socials a:hover {
  color: #bdbdbd;
}
.footer-stuhia .footer-title {
  font-weight: 600;
  margin-bottom: 18px;
  font-size: 1.1rem;
}
.footer-stuhia .footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.footer-stuhia .footer-links a {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-stuhia .footer-links a:hover {
  color: #bdbdbd;
}
.footer-stuhia .footer-newsletter {
  max-width: 400px;
}
.footer-stuhia .newsletter-desc {
  margin-bottom: 16px;
  color: #bdbdbd;
}
.footer-stuhia .newsletter-form {
  display: flex;
  border: 1px solid #bdbdbd;
  border-radius: 32px;
  overflow: hidden;
  background: #232323;
}
.footer-stuhia .newsletter-form input {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 1rem;
  outline: none;
}
.footer-stuhia .newsletter-form button {
  background: none;
  border: none;
  color: #fff;
  padding: 0 20px;
  font-size: 1.3rem;
  cursor: pointer;
  transition: color 0.2s;
}
.footer-stuhia .newsletter-form button:hover {
  color: #bdbdbd;
}
.footer-stuhia .footer-bottom {
  border-top: 1px solid #444;
  margin-top: 32px;
  padding: 18px 40px 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}
.footer-stuhia .footer-copyright {
  color: #bdbdbd;
  font-size: 0.95rem;
}
.footer-stuhia .footer-payments {
  display: flex;
  gap: 8px;
}
.footer-stuhia .footer-payments img {
  height: 32px;
  background: #fff;
  border-radius: 4px;
  padding: 2px 6px;
}
@media (max-width: 900px) {
  .footer-stuhia .footer-main {
    flex-direction: column;
    gap: 32px;
    padding: 0 16px;
  }
  .footer-stuhia .footer-bottom {
    flex-direction: column;
    gap: 16px;
    padding: 18px 16px 0 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FooterStuhia.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;IACb,iCAAiC;;AAErC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,yBAAyB;EAC3B;AACF","sourcesContent":[".footer-stuhia {\n  background: #2e2e2e;\n  color: #fff;\n  padding: 48px 0 0 0;\n  font-size: 16px;\n    font-family: \"Gilroy\", sans-serif;\n\n}\n.footer-stuhia .footer-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 40px;\n  flex-wrap: wrap;\n}\n.footer-stuhia .footer-col {\n  flex: 1 1 220px;\n  margin-bottom: 32px;\n}\n.footer-stuhia .footer-logo {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 24px;\n  letter-spacing: -1px;\n}\n.footer-stuhia .footer-socials {\n  display: flex;\n  gap: 16px;\n  margin-top: 16px;\n}\n.footer-stuhia .footer-socials a {\n  color: #fff;\n  font-size: 1.3rem;\n  transition: color 0.2s;\n}\n.footer-stuhia .footer-socials a:hover {\n  color: #bdbdbd;\n}\n.footer-stuhia .footer-title {\n  font-weight: 600;\n  margin-bottom: 18px;\n  font-size: 1.1rem;\n}\n.footer-stuhia .footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.footer-stuhia .footer-links a {\n  color: #fff;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n.footer-stuhia .footer-links a:hover {\n  color: #bdbdbd;\n}\n.footer-stuhia .footer-newsletter {\n  max-width: 400px;\n}\n.footer-stuhia .newsletter-desc {\n  margin-bottom: 16px;\n  color: #bdbdbd;\n}\n.footer-stuhia .newsletter-form {\n  display: flex;\n  border: 1px solid #bdbdbd;\n  border-radius: 32px;\n  overflow: hidden;\n  background: #232323;\n}\n.footer-stuhia .newsletter-form input {\n  flex: 1;\n  padding: 12px 20px;\n  border: none;\n  background: transparent;\n  color: #fff;\n  font-size: 1rem;\n  outline: none;\n}\n.footer-stuhia .newsletter-form button {\n  background: none;\n  border: none;\n  color: #fff;\n  padding: 0 20px;\n  font-size: 1.3rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.footer-stuhia .newsletter-form button:hover {\n  color: #bdbdbd;\n}\n.footer-stuhia .footer-bottom {\n  border-top: 1px solid #444;\n  margin-top: 32px;\n  padding: 18px 40px 0 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.footer-stuhia .footer-copyright {\n  color: #bdbdbd;\n  font-size: 0.95rem;\n}\n.footer-stuhia .footer-payments {\n  display: flex;\n  gap: 8px;\n}\n.footer-stuhia .footer-payments img {\n  height: 32px;\n  background: #fff;\n  border-radius: 4px;\n  padding: 2px 6px;\n}\n@media (max-width: 900px) {\n  .footer-stuhia .footer-main {\n    flex-direction: column;\n    gap: 32px;\n    padding: 0 16px;\n  }\n  .footer-stuhia .footer-bottom {\n    flex-direction: column;\n    gap: 16px;\n    padding: 18px 16px 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
